import { selectLegacyFeatureFlagValue } from '@libs/focus-frontend-store/src/User/selectors';

import { setLegacyFeatureFlag } from './actions';

export const get = (key) => selectLegacyFeatureFlagValue(key)(window.top.store.getState());

export const set = (key, value, extraInfo = null) => {
  window.top.store.dispatch(setLegacyFeatureFlag(key, value, extraInfo));
};
